import React, { useState } from 'react';
import './Contact.css';

function ContactEn() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    message: ''
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    // Form will be submitted to FormSubmit
    // Show success message after submission
    setIsSubmitted(true);
    setTimeout(() => {
      setIsSubmitted(false);
    }, 5000);
  };

  return (
    <section className="contact" id="contact">
      <div className="container">
        <div className="contact-content">
          <div className="contact-info">
            <h2 className="contact-info-title">Contact Us</h2>
            
            <div className="info-item">
              <div className="info-text">
                <h3>Location</h3>
                <p>Calle de la Gerreria, 26, 1ºB,<br/>07002, Palma, Balearic Islands</p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-text">
                <h3>Phone</h3>
                <p><a href="tel:+34871533824">+34 871 533 824</a></p>
              </div>
            </div>

            <div className="info-item">
              <div className="info-text">
                <h3>Email</h3>
                <p><a href="mailto:info@tabiagroup.com">info@tabiagroup.com</a></p>
              </div>
            </div>
          </div>

          <form 
            className="contact-form" 
            action="https://formsubmit.co/info@tabiagroup.com" 
            method="POST"
            onSubmit={handleSubmit}
          >
            {/* FormSubmit Configuration */}
            <input type="hidden" name="_subject" value="New message from Tabia Group website" />
            <input type="hidden" name="_captcha" value="false" />
            <input type="hidden" name="_template" value="table" />
            <input type="hidden" name="_next" value={window.location.href} />
            
            {isSubmitted && (
              <div className="success-message">
                Thank you for your message! We will contact you soon.
              </div>
            )}
            
            <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  placeholder="Your name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  placeholder="Your email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <input
                type="tel"
                name="phone"
                placeholder="Phone number"
                value={formData.phone}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <textarea
                name="message"
                placeholder="How can we help you..."
                value={formData.message}
                onChange={handleChange}
                rows="5"
              ></textarea>
            </div>

            <button type="submit" className="submit-btn">
              Send
            </button>
          </form>
        </div>
      </div>
    </section>
  );
}

export default ContactEn;
